export default __webpack_public_path__ + "static/independenceday2020-1908d65c0d93d2fd1516f8fbccd786b3.jpg";